import { useDeviceType } from '@cian/ui-kit';
import React, { useCallback } from 'react';
import { RateNumberInput } from 'shared/components/RateNumberInput';

export interface IRateNumberInputContainerProps {
  values: number[];
  index: number;
  label: string;
  onIndexChange: (index: number) => void;
  showSetMaxButton?: boolean;
  setMaxButtonLabel?: string;
  width?: number;
}

export const RateNumberInputContainer: React.FC<IRateNumberInputContainerProps> = ({
  values,
  index,
  label,
  onIndexChange,
  showSetMaxButton,
  setMaxButtonLabel,
  width,
}) => {
  const value = values[index];
  const isMin = index === 0;
  const isMax = index === values.length - 1;

  const device = useDeviceType();

  const decrement = useCallback(() => onIndexChange(Math.max(0, index - 1)), [index, onIndexChange]);
  const increment = useCallback(
    () => onIndexChange(Math.min(values.length - 1, index + 1)),
    [index, onIndexChange, values.length],
  );
  const setMax = useCallback(() => onIndexChange(values.length - 1), [onIndexChange, values.length]);

  return (
    <RateNumberInput
      device={device}
      value={value}
      isMin={isMin}
      isMax={isMax}
      label={label}
      onDecrement={decrement}
      onIncrement={increment}
      onSetMax={showSetMaxButton ? setMax : undefined}
      setMaxButtonLabel={setMaxButtonLabel}
      width={width}
    />
  );
};
